import React from 'react';
import useUtilizationPerYearAverageChart from './hooks/useUtilizationPerYearAverageChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const UtilizationPerYearAverage = ({ heigth = 400 }) => {
    const { series, subtitles } = useUtilizationPerYearAverageChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={subtitles}
            title={`Média da Utilização Mensal por Ano`}
        />
    );
};
